module.exports = __webpack_public_path__ + "static/fonts/iconfont.1e528e3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff?t=1551407126619
// module id = N9M4
// module chunks = 208